import { take, call, put, fork } from 'redux-saga/effects';
import fetchApi from '../../../../../utils/fetchApi';

function* getCalcPlanFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('GET_CALC_PLAN');

    try {
      const response = yield call(fetchApi, `Billings/calcPlan/${payload.registerModel}`);
      if (response && !response.error) {
        yield put({
          type: 'GET_CALC_PLAN_SUCCESS',
          payload: response
        });
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* checkOutFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('CHECK_OUT');
    const dataSend = {
      total: payload.total,
      shipping_address: payload.shipping_address,
      promotion_code: payload.promotion_code,
      // merchant_preferences: {
      // 	cancel_url: Configs.paypalUrlCallback.cancelUrl,
      // 	return_url: Configs.paypalUrlCallback.returnUrl
      // }
    };
    try {
      const response = yield call(fetchApi, 'Billings/createPlan', dataSend, { method: 'POST' });
      if (response && !response.error) {
        yield put({
          type: 'CREATE_PLAN_SUCCESS',
          payload: response
        });
        if (next && typeof next === 'function') {
          next(response);
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* executePlanFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('EXECUTE_PLAN');
    const dataSend = {
      paymentToken: payload.token
    };
    try {
      const response = yield call(fetchApi, 'Billings/executePlan', dataSend, { method: 'POST' });
      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next(response);
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* doExecutePaymentFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('DO_EXECUTE_PAYMENT');
    try {
      // const response = yield call(fetchApi, 'Billings/executePayment', payload, { method: 'POST' });
      const response = yield call(fetchApi, 'Billings/executePaymentV3', payload, { method: 'POST' })
      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next(response);
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* getTerminatePlanFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { next } = yield take('GET_TERMINATE_PLAN');
    try {
      const response = yield call(fetchApi, 'Billings/terminatePlan');
      if (response && !response.error) {
        yield put({
          type: 'GET_TERMINATE_PLAN_SUCCESS',
          payload: response
        });
        if (next && typeof next === 'function') {
          next(response);
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* terminatePlanFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { next } = yield take('TERMINATE_PLAN');
    try {
      const response = yield call(fetchApi, 'Billings/terminatePlan', {}, { method: 'POST' });
      if (response && !response.error) {
        // yield put({
        // 	type: 'TERMINATE_PLAN_SUCCESS',
        // 	payload: response
        // });
        if (next && typeof next === 'function') {
          next(response);
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* upgradeGoldFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('UPGRADE_GOLD');
    try {
      const curDate = new Date();
      curDate.setMonth(curDate.getMonth() + 1);
      const endContract = `${curDate.getFullYear()}${curDate.getMonth() + 1}${curDate.getDate()}`;

      const dataSend = {
        userId: payload.userId,
        roleName: 'gold',
        endContract,
        haveDiscount: true,
      };

      const response = yield call(fetchApi, 'users/role', dataSend, { method: 'POST' });
      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next(response);
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* contactUsFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('CONTACT_US');
    try {
      const response = yield call(fetchApi, 'Accounts/send-email', payload, { method: 'POST' });
      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

export default function* paymentFlow() {
  yield fork(checkOutFlow);
  yield fork(executePlanFlow);
  yield fork(doExecutePaymentFlow);
  yield fork(getTerminatePlanFlow);
  yield fork(terminatePlanFlow);
  yield fork(upgradeGoldFlow);
  yield fork(contactUsFlow);
  yield fork(getCalcPlanFlow);
}



// WEBPACK FOOTER //
// ./routes/app/routes/checkout/saga/index.js